import React, { useState, useEffect } from 'react'
import { getUtmValuesFromCookie } from '../utils/thirdPartyUtils'

function fillUtmParams() {
  let utmValues = getUtmValuesFromCookie()
  let marketoForm = window.MktoForms2.allForms()[0]
  marketoForm.addHiddenFields({
    ftutmsource: `${utmValues.__ft_utm_source}`,
    ftutmmedium: `${utmValues.__ft_utm_medium}`,
    ftutmcampaign: `${utmValues.__ft_utm_campaign}`,
    ftutmterm: `${utmValues.__ft_utm_term}`,
    ftutmcontent: `${utmValues.__ft_utm_content}`,
    ltutmsource: `${utmValues.__lt_utm_source}`,
    ltutmmedium: `${utmValues.__lt_utm_medium}`,
    ltutmcampaign: `${utmValues.__lt_utm_campaign}`,
    ltutmterm: `${utmValues.__lt_utm_term}`,
    ltutmcontent: `${utmValues.__lt_utm_content}`,
  })
}

function appendScript(baseUrl, setScriptLoaded) {
  if (window.MktoForms2) return setScriptLoaded(true)

  const script = document.createElement('script')
  script.src = `${baseUrl}/js/forms2/js/forms2.min.js`
  script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null)
  document.body.appendChild(script)
}

function useMarketo({ baseUrl, munchkinId, formId, toggleCheckbox }) {
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [formLoaded, setFormLoaded] = useState(false)

  useEffect(() => {
    if (scriptLoaded) {
      window.MktoForms2.loadForm(baseUrl, munchkinId, formId, (form) => {
        if (toggleCheckbox) {
          // For webinars series
          if (toggleCheckbox === 'all') {
            const checkboxes = form.getFormElem().find('input[type=checkbox]')
            checkboxes.each((i) => {
              checkboxes[i].checked = true
            })
          } else if (form.getFormElem().find('input[type=checkbox]').length > 0) {
            form.getFormElem().find(`.mktoCheckboxList label:contains("0${toggleCheckbox})")`).prev()[0].checked = true
          }
        }

        form.onSuccess((cb) => {
          setFormLoaded(true)

          if (formId === '2113') {
            const thankYouMessage =
              '<h2 class="title is-2">Thank you for your interest in Trajectory 2021.</h2><p>We will reach out when tickets are available.</p>'

            document.querySelector('.ReactModalPortal .card.formCard').innerHTML = thankYouMessage;
            return false
          }
        })
      })
    }
    if (formLoaded) {
      fillUtmParams()
    }
    appendScript(baseUrl, setScriptLoaded)
  }, [scriptLoaded, baseUrl, munchkinId, formId, formLoaded])
}

const MarketoForm = ({ formId, toggleCheckbox }) => {
  const baseUrl = '//app-sj31.marketo.com'
  const munchkinId = '850-KKH-319'

  useMarketo({ baseUrl, munchkinId, formId, toggleCheckbox })

  return (
    <div className="mkto-form-container">
      <form id={`mktoForm_${formId}`} />
      <style>{`.mktoForm .mktoCheckboxList > input { margin-top: 3px !important;}`}</style>
    </div>
  )
}

export default MarketoForm
